import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=1b61714e&scoped=true"
import script from "./ContactDetails.vue?vue&type=script&lang=js"
export * from "./ContactDetails.vue?vue&type=script&lang=js"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=1b61714e&prod&lang=scss&scoped=true"
import style1 from "./ContactDetails.vue?vue&type=style&index=1&id=1b61714e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b61714e",
  null
  
)

export default component.exports